import React from 'react'
import SbEditable from 'storyblok-react'
import Image from 'gatsby-theme-kn/src/components/atoms/Image'
import Headline from 'gatsby-theme-kn/src/components/atoms/Headline'
import Link from 'gatsby-theme-kn/src/components/atoms/Link'
import Richtext from '../atoms/Richtext'

function iconExists(item) {
  return item?.icon?.filename === '' || item?.icon?.filename === null
}

const ProductInnovationBlock = ({ block }) => {
  return (
    <SbEditable content={block}>
      <section className="product-innovation-block">
        <div className="product-innovation-block-wrapper">
          <div className="product-innovation-block-container">
            <div className="product-innovation-block-text">
              <div className="product-innovation-block-text-inner">
                <Headline
                  kicker={block.kicker}
                  headline={block.headline}
                  headline_level="h3"
                  tagName="h3"
                />
                {block.features?.length > 0 && (
                  <ul className="product-innovation-block-feature-list">
                    {block.features?.map((item, index) => (
                      <li
                        key={index}
                        className="product-innovation-block-feature-list-item"
                      >
                        {!iconExists(item) && (
                          <Image
                            className="product-innovation-block-feature-list-item-icon"
                            image={item.icon}
                          />
                        )}
                        <div className="product-innovation-block-feature-list-item-text">
                          <Richtext text={item.text} />
                        </div>
                      </li>
                    ))}
                  </ul>
                )}
                {block?.link_text?.length > 0 && (
                  <Link className="btn btn-primary" link={block.link}>
                    {block.link_text}
                  </Link>
                )}
              </div>
            </div>
            <div className="product-innovation-block-image">
              <Image image={block.image} />
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default ProductInnovationBlock
